function gallerySliderInit(){


		function initSlider() {
		  $('.js-gallery-slider').slick({
		    adaptiveHeight: true,
		    arrows: false,
		    dots: true,
		    zindex: 100,
		    slide: '.gallery-works__row',
		    mobileFirst: true,
		    responsive: [
              {
	              breakpoint: 1024,
	              settings: 'unslick'
              },
           
            
		     ]
		  });
		}

	// if ($(window).width() < 1024 ) {
		initSlider();

	// }

	var flag = false;

	if ($(window).width() > 1024) {
		flag = true
	}

	$(window).on('resize', function(event) {

		if ($(this).width() < 1024) {

			if (flag) {
			 initSlider();
			}

			flag = false
		} else {
			flag = true 
		}
	});
}
